cv.ChangePasswordView = Marionette.LayoutView.extend({
  template : cv.Templates['change_password/view'],

  behaviors : [{
    behaviorClass : cv.FormBehavior,
		suppress_notifications: true
  }],

	events : {
	},

	validation: {
		current_password: [{
			required: true,
			msg: 'Please enter current password.'
		}],
		password: [{
			required: true,
			msg: 'Required'
	  },{
			minLength : 6,
			msg : "Password must be at least 6 characters"
		}],
	  confirm_password: [{
			required: true,
			msg: 'Required'
	  },{
	    	equalTo: 'password',
	    	msg: 'Passwords must match'
	  }]
	},

	initialize: function(options){
		this.options = _.extend(this.options, options);
		this.model = new Backbone.Model({
			current_password : '',
			password : '',
			confirm_password : ''
		});

		this.listenTo(this, 'form:saved', function(){
			$.ajax({
        url: cv.api_path + '/users/' + cv.user.get('id') + '/change_password',
        dataType: "json",
        data: {
					current_password : this.model.get('current_password'),
          password : this.model.get('password'),
          confirm_password : this.model.get('password')
        },
        type: "post",
        success: _.bind(function(data){
					this.$('input').val('');
					
          vent.trigger('notif:success', 'Your password has been changed.');
        }, this),
        error: _.bind(function(data){
					Backbone.Validation.error(this, 'current_password', 'Invalid');
					vent.trigger('notif:error', $.parseJSON(data.responseText).data);
        }, this)
      });
		}, this);

		console.log('ChangePasswordView initialized');
	},

	onDestroy: function(){
	}
});
